import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ClienteComboOutput } from 'src/app/@shared/models/consulta-detalhe';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
@Injectable({
  providedIn: 'root'
})
export class LoadArquivoService {
    [x: string]: any;
    constructor(private http: HttpClient) { }

    private httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    private filtro(obj: unknown): URLSearchParams {
      const filter = Object.entries(obj).filter(([_, v]) => v);
      return new URLSearchParams(filter);
    }
  
    

    loadArquivo(obj: any): Observable<any[]> {
      const params = this.filtro(obj).toString();
      return this.http.get<any[]>(`Load/LoadArquivo?${params}`, this.httpOptions);
    }
    
    public getClientesAtivos(): Observable<ClienteComboOutput[]> {
      return this.http.get<ClienteComboOutput[]>(
        `IntegracaoNotFis/ListarClientesAtivos`
      );
    }  
  
    public exportarExcelMonitoramento(data: Date, agente: any): Observable<any[]> {
      return this.http.get<any[]>(`LoadArquivo/ExportarMonitoramento?dataFim=${data.toISOString().split('T')[0]}${agente ? `&agenteOrigemId=${agente}`: ''}`, httpOptions);
    };

    public exportarDetalhes(data): Observable<any[]> {
      return this.http.get<any[]>(`LoadArquivo/ExportarDetalhes?dataFim=${data.toISOString().split('T')[0]}`, httpOptions);
    };

    
}